import { ThemeSwitch } from '@components/main/theme-switch';
import { useSession } from '@context/sessionProvider';
import { BookOpenIcon } from '@icons/book-open-icon';
import { HomeIcon } from '@icons/home-icon';
import {
	Button,
	Chip,
	Link,
	Navbar,
	NavbarContent,
	NavbarItem,
	NavbarMenu,
	NavbarMenuItem,
	NavbarMenuToggle,
} from '@nextui-org/react';
import { useRouter } from 'next/router';
import React, { ReactElement } from 'react';

const NAVIGATION_PANEL = [
	{ label: 'Timers', href: '/', Icon: HomeIcon },
	{ label: 'User guide', href: '/help', Icon: BookOpenIcon },
];

export default function Navigation(): ReactElement {
	const router = useRouter();
	const sessionData = useSession();

	const { pathname } = router;
	const [isMenuOpen, setIsMenuOpen] = React.useState(false);

	const closeMenu = () => setIsMenuOpen(false);

	return (
		<Navbar isMenuOpen={isMenuOpen} onMenuOpenChange={setIsMenuOpen} isBordered maxWidth='full'>
			<NavbarContent className='sm:hidden'>
				<NavbarMenuToggle aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} />
			</NavbarContent>

			<NavbarContent justify='start' className='hidden gap-4 sm:flex'>
				{NAVIGATION_PANEL.map(({ Icon, href, label }) => (
					<NavbarItem key={href} isActive={pathname === href} className='h-[40px]'>
						<Link href={href} aria-label={label} className='flex items-center text-[#006FEE]'>
							<Icon />
						</Link>
					</NavbarItem>
				))}
			</NavbarContent>

			<NavbarContent justify='end' className='gap-4'>
				<NavbarItem className='hidden sm:flex'>
					<Chip color='primary' size='sm'>
						<span>Current plan: </span>
						<span className='amasty-plan-name'>{sessionData.user.planName}</span>
					</Chip>
				</NavbarItem>
				<NavbarItem className='hidden sm:flex'>
					<Button as={Link} color='primary' href={sessionData.user.billingLink} variant='flat' target='_blank'>
						Pricing
					</Button>
				</NavbarItem>
				<NavbarItem className='hidden sm:flex'>
					<ThemeSwitch className='amasty-theme-switch' />
				</NavbarItem>
			</NavbarContent>

			<NavbarMenu className='z-50'>
				{NAVIGATION_PANEL.map(({ label, href }) => (
					<NavbarMenuItem key={href} isActive={pathname === href}>
						<Link
							color={pathname === href ? 'primary' : 'foreground'}
							className='w-full'
							href={href}
							size='lg'
							onPress={closeMenu}
						>
							{label}
						</Link>
					</NavbarMenuItem>
				))}
				<NavbarMenuItem>
					<Link
						color='foreground'
						className='w-full'
						href={sessionData.user.billingLink}
						size='lg'
						target='_blank'
						onPress={closeMenu}
					>
						Pricing
					</Link>
				</NavbarMenuItem>
				<NavbarMenuItem>
					<ThemeSwitch />
				</NavbarMenuItem>
			</NavbarMenu>
		</Navbar>
	);
}
